import './typedefs'
import {
  VIDEOS_KEY,
  SERIES_KEY,
  FAQS_KEY,
  TERM_KEY,
  PROMOTIONS_KEY,
  PRODUCTS_KEY,
  ACTIONS_SETTINGS_KEY,
} from './entities'

export const NODES_RECIEVED = 'NODES_RECIEVED'
export const REMOVE_NODES = 'REMOVE_NODES'
export const GET_PM_MULTIPLE_NODES = 'GET_PM_MULTIPLE_NODES'
export const NODE_IMPRESSED = 'NODE_IMPRESSED'
export const CLEAR_ALL_NODES_IMPRESSION = 'CLEAR_ALL_NODES_IMPRESSION'
export const RESET_NODES_BY_KEY = 'RESET_NODES_BY_KEY'

/**
 * @typedef {Object} GetPmMultipleNodesActionPayload
 * @property {NodeId[]} ids A list of node ids
 * @property {String} [language] The content requested language
 * @property {Sting|Number} key specify the type of node
 * SettingsSymbol is symbol. Node: there is no way in JSDoc to specify Symbol
 * @property {RequestSettings} [SettingsSymbol={}]
 */

/**
 * @typedef {Object} GetPmMultipleNodesAction
 * @property {String} type - action type
 * @property {GetPmMultipleNodesActionPayload} payload
 */

/**
 * getNodes GET_PM_MULTIPLE_NODES action creator
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getNodes (payload) {
  return { type: GET_PM_MULTIPLE_NODES, payload }
}

/**
 * getVideos GET_PM_MULTIPLE_NODES action creator for videos
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getVideos (payload) {
  /** @type {RequestSettings} */
  const settings = { exact: true }

  return {
    type: GET_PM_MULTIPLE_NODES,
    payload: {
      ...payload,
      key: VIDEOS_KEY,
      [ACTIONS_SETTINGS_KEY]: settings,
    },
  }
}

export function clearNodes (payload = {}) {
  return { type: REMOVE_NODES, payload }
}

/**
 * @typedef {Object} NodesWithError
 * @param {NodeId} id A list of nodes content
 * @param {Object} error
 */

/**
 * @typedef {Object} Nodes
 * @param {NodeId} id A list of nodes content
 * @param {Object} data
 */

/**
 * @typedef {Object} nodesRecievedActionPayload
 * @param {Nodes[]|NodesWithError[]} nodes A list of nodes content
 * @param {String} [language] The content requested language
 * @param {Sting|Number} key specify the type of node
 */

/**
 * @typedef {Object} nodesRecievedAction
 * @property {String} type - action type
 * @property {nodesRecievedActionPayload} payload
 */
/**
 * nodesRecieved NODES_RECIEVED action creator
 * @param {nodesRecievedActionPayload} payload
 * @returns {nodesRecievedAction}
 */
export function nodesRecieved (payload) {
  return {
    type: NODES_RECIEVED,
    payload,
  }
}

/**
 * nodeImpressed NODE_IMPRESSED action creator
 * @param {Object} payload
 * @param {NodeId} payload.id
 * @param {String} payload.language
 * @param {String} payload.key
 */
export function nodeImpressed (payload) {
  return {
    type: NODE_IMPRESSED,
    payload,
  }
}

/**
 * @typedef {Object} clearAllNodesImpressedPayload
 * @property {Object} payload
 * @property {String} payload.key
 */

/**
 * clearAllNodesImpressed CLEAR_ALL_NODES_IMPRESSION action creator
 * @param {clearAllNodesImpressedPayload} payload
 */
export function clearAllNodesImpression (payload) {
  return {
    type: CLEAR_ALL_NODES_IMPRESSION,
    payload,
  }
}

/**
 * clearAllVideosImpressed CLEAR_ALL_NODES_IMPRESSION action creator for videos
 * @returns {clearAllNodesImpressedPayload}
 */
export function clearAllVideosImpressed () {
  return {
    type: CLEAR_ALL_NODES_IMPRESSION,
    payload: {
      key: VIDEOS_KEY,
    },
  }
}

/**
 * clearAllSeriesImpressed CLEAR_ALL_NODES_IMPRESSION action creator for videos
 * @returns {clearAllNodesImpressedPayload}
 */
export function clearAllSeriesImpressed () {
  return {
    type: CLEAR_ALL_NODES_IMPRESSION,
    payload: {
      key: SERIES_KEY,
    },
  }
}

/**
 * getVideos GET_PM_MULTIPLE_NODES action creator for series
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getSeries (payload) {
  /** @type {RequestSettings} */
  const settings = { exact: true }

  return {
    type: GET_PM_MULTIPLE_NODES,
    payload: {
      ...payload,
      key: SERIES_KEY,
      [ACTIONS_SETTINGS_KEY]: settings,
    },
  }
}

/**
 * getFaqs GET_PM_MULTIPLE_NODES action creator for faqs
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getFaqs (payload) {
  /** @type {RequestSettings} */
  const settings = { exact: true }

  return {
    type: GET_PM_MULTIPLE_NODES,
    payload: {
      ...payload,
      key: FAQS_KEY,
      [ACTIONS_SETTINGS_KEY]: settings,
    },
  }
}

/**
 * getTerms GET_PM_MULTIPLE_NODES action creator for terms
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getTerms (payload) {
  return {
    type: GET_PM_MULTIPLE_NODES,
    payload: {
      ...payload,
      key: TERM_KEY,
    },
  }
}

/**
 * getProducts GET_PM_MULTIPLE_NODES action creator for products
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getProducts (payload) {
  return {
    type: GET_PM_MULTIPLE_NODES,
    payload: {
      ...payload,
      key: PRODUCTS_KEY,
    },
  }
}

/**
 * getPromotions GET_PM_MULTIPLE_NODES action creator for promotions
 * @param {GetPmMultipleNodesActionPayload} payload
 * @returns {GetPmMultipleNodesAction}
 */
export function getPromotions (payload) {
  /** @type {RequestSettings} */
  const settings = { exact: true }

  return {
    type: GET_PM_MULTIPLE_NODES,
    payload: {
      ...payload,
      key: PROMOTIONS_KEY,
      [ACTIONS_SETTINGS_KEY]: settings,
    },
  }
}

/**
 * nodesRecieved NODES_RECIEVED action creator for videos
 * @param {nodesRecievedActionPayload} payload
 * @returns {nodesRecievedAction}
 */
export function videosRecieved (payload) {
  return {
    type: NODES_RECIEVED,
    payload: {
      ...payload,
      key: VIDEOS_KEY,
    },
  }
}

/**
 * resetNodesByKey, resets a section of the node store
 * @param {key} payload
 */
export function resetNodesByKey (key) {
  return {
    type: RESET_NODES_BY_KEY,
    payload: { key },
  }
}
